/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkItemComment
 */
export interface WorkItemComment {
    /**
     * 
     * @type {Date}
     * @memberof WorkItemComment
     */
    createdOn?: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkItemComment
     */
    author?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemComment
     */
    authorRole?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkItemComment
     */
    comment?: string;
}

/**
 * Check if a given object implements the WorkItemComment interface.
 */
export function instanceOfWorkItemComment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WorkItemCommentFromJSON(json: any): WorkItemComment {
    return WorkItemCommentFromJSONTyped(json, false);
}

export function WorkItemCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkItemComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdOn': !exists(json, 'createdOn') ? undefined : (new Date(json['createdOn'])),
        'author': !exists(json, 'author') ? undefined : json['author'],
        'authorRole': !exists(json, 'authorRole') ? undefined : json['authorRole'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function WorkItemCommentToJSON(value?: WorkItemComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdOn': value.createdOn === undefined ? undefined : (value.createdOn.toISOString()),
        'author': value.author,
        'authorRole': value.authorRole,
        'comment': value.comment,
    };
}

